import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpCreditMemoItem from '../../../Domain/CreditMemo/TpCreditMemoItem';
import TpCreditMemoService from '../../../Services/CreditMemo/TpCreditMemoService';
import TpCreditMemoSearchParams from './TpCreditMemoSearchParams';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditTpCreditMemoWindowDescription from './EditTpCreditMemoWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import StatusChangeTpCreditMemoWindowDescription from './StatusChangeTpCreditMemoWindowDescription';

export default class TpCreditMemoAdmin extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpCreditMemoSearchParams(),
    };
    if (this.props.tpClientInvoiceId) {
      this.state.searchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
      this.state.searchItem.SelectedOfficeIds = [];
    }

    this.refresh = this.refresh.bind(this);
    TpCreditMemoItem.editFunction = this.editFunction.bind(this);
    TpCreditMemoItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  statusChangeFunction(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  editFunction(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new TpCreditMemoItem()}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditTpCreditMemoWindowDescription}
            errorCode={'TPCMA70'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditTpCreditMemoWindowDescription}
            errorCode={'TPCMA81'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.StatusUpdate,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={StatusChangeTpCreditMemoWindowDescription}
            errorCode={'TPCMA92'}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Right,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem }),
              label: 'Create',
              tooltip: 'Create',
              roleKey: 'tpcreditmemo_createandmodifycredit',
              iconName: 'fa-solid fa-plus-circle',
              hidden: !!this.props.tpClientInvoiceId,
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpCreditMemoItem}
          serviceFunction={TpCreditMemoService.GetListBySearching}
          convertDBItemsFunction={TpCreditMemoService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={'CaspianClientName'}
          showSearchStrip={!this.props.tpClientInvoiceId}
          searchParamsType={TpCreditMemoSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Client ID/Name and Invoice ID...'
          errorCode='TPCMA138'
        />
      </div>
    );
  }
}
